export const isInterlinkingEnabled = (toggles) => toggles?.isInterlinkingEnabled || false;

export const isInterlinkingLogsEnabled = (toggles) => toggles?.isInterlinkingLogsEnabled || false;
